import React from "react";

// MUI
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";

// MUI Icons
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import LanguageIcon from "@mui/icons-material/Language";
import LinkIcon from "@mui/icons-material/Link";

// Types
import { LinkType } from "@/@types/controls/controls";

type LinkAdornmentProps = {
  disabled: boolean;
  linkType: LinkType;
  href: string;
}

function LinkAdornment(props: LinkAdornmentProps) {

  const { disabled, linkType, href } = props;

  const handleMouseDown = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
  };

  const handleMouseUp = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
  };

  const getIcon = () => {
    const color = disabled ? "disabled" : "primary";

    switch (linkType) {
      case "mail":
        return <MailOutlineIcon color={color} />;
      case "url":
        return <LanguageIcon color={color} />;
      default:
        return <LinkIcon color={color} />;
    }
  };

  const Icon = getIcon();

  return (
    <InputAdornment position="end">
      <IconButton
        tabIndex={-1}
        disabled={disabled}
        onMouseDown={handleMouseDown}
        onMouseUp={handleMouseUp}
        onClick={() => { window.open(href); }}
        edge="end">
        {Icon}
      </IconButton>
    </InputAdornment>
  );
}

export default LinkAdornment;